// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import jwtDecode from 'jwt-decode'

require('../src/assets/mycss.css')
require('../node_modules/bootstrap/dist/css/bootstrap.css')
require('../node_modules/bootstrap/dist/js/bootstrap.min.js')

Vue.config.productionTip = false

function checkTokenExpiration () {
  const token = localStorage.getItem('usertoken')
  if (token) {
    const decoded = jwtDecode(token)
    const currentTime = Date.now() / 1000 // aktuális idő másodpercben
    if (decoded.exp < currentTime) {
      // Token lejárt, kijelentkezés
      localStorage.removeItem('usertoken')
      localStorage.removeItem('userType')
      localStorage.removeItem('auth')
      router.push({ name: 'Login' })
    }
  }
}

// Ellenőrizd a token érvényességét minden alkalommal, amikor a felhasználó navigál
router.beforeEach((to, from, next) => {
  checkTokenExpiration()
  next()
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js